import { MapsAPILoader } from '@agm/core';
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class MapsService {
  public addressEvent = new BehaviorSubject(false);
  getaddressEvent = this.addressEvent.asObservable();


  constructor(
    public mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) { }

  autoFillLocation(element: any, root: any) {
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(element.nativeElement, {
        // types: ['(regions)'],
        componentRestrictions: {
          country: 'us'
        }
      });
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place = autocomplete.getPlace();
          let zipcode, city, state, dummyobj;
          for (let i = 0; i < place.address_components.length; i++) {
            if (place.address_components[i].types[0] === 'route') {              
              place.address = place.name;
            }
            if (place.address_components[i].types[0] === 'postal_code') { // For Zipcode
              zipcode = place.address_components[i].long_name;
            }
            if (place.address_components[i].types[0] === 'locality') { // For City
              city = place.address_components[i].long_name;
            }
            if (place.address_components[i].types[0] === 'sublocality_level_1') { // For City
              city = place.address_components[i].long_name;
            }
            if (place.address_components[i].types[0] === 'sublocality') { // For City
              city = place.address_components[i].long_name;
            }
            if (place.address_components[i].types[0] === 'administrative_area_level_1') { // For State
              state = place.address_components[i].long_name;
            }

          }
          dummyobj = { zipcode, city, state, address: place.formatted_address, longAddress: place.formatted_address, root }
          this.setAddressEvent(dummyobj);
        });
      });
    });
  }

  setAddressEvent(data: any){
    return this.addressEvent.next(data);
  }
}
